import { QueryClient } from '@tanstack/react-query';

/**
 * One shared response cache for portal data. staleTime keeps dashboard →
 * application → back navigations instant (rendered from cache, no spinner)
 * while anything older than a minute revalidates in the background. One retry
 * absorbs transient blips; 401s never reach here (lib/api redirects first).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
